/* global fbq */
import $ from 'jquery'
import isBefore from 'date-fns/isBefore'
import isToday from 'date-fns/isToday'
import isPast from 'date-fns/isPast'
import Cookies from 'js-cookie'
import 'whatwg-fetch'

fetch('/wp-content/uploads/spirit-of-generosity.json')
	.then(response => response.json())
	.then(data => calendar_init(data))

function calendar_init(data) {
	const path = '/wp-content/themes/wp-foundation-six/assets/images/spirit-of-generosity/calendar-assets/icons/'
	const today = new Date()

	const list_items = data.map((item, index) => {
		const item_date = new Date(item.date)
		const date_has_been_opened = has_been_opened(index)

		let icon = ''
		if (!date_has_been_opened) {
			icon = `<a
					href=""
					data-date="${item.date}"
					class="day-icon
						${isPast(item_date) || isToday(item_date) ? 'active' : ''}
						${isToday(item_date) ? 'pulse' : ''}
					"
				>
					${!isToday(item_date) ? '<p class="rejected">No peeking!</p>' : ''}
					<img src="${path + item.icon}" />
				</a>`
		}

		let description = ''
		if (isBefore(item_date, today)) {
			description = `<div class="day-description">
				<p>${item.description}</p>
			</div>`
		}

		const element = `<li data-number="${index + 1}" class="${date_has_been_opened ? 'active' : ''}">
			${icon}
			${description}
		</li>`

		return element
	})

	$('#spirit_of_generosity_root').append(list_items.join(''))

	calendar_date_events()
}

function calendar_date_events() {
	const anchors = $('#spirit_of_generosity_root').find('a')

	$(anchors).on('click', function (event) {
		event.preventDefault()

		const item_date = new Date($(this).data('date'))
		$('#spirit_of_generosity_root').data('current', item_date)

		fbq('track', 'Event Day ' + item_date)

		if (isPast(item_date) || isToday(item_date)) {
			$(this).fadeOut().parent('li').addClass('active')

			const index = $(this).parent('li').data('number')

			set_cookies_index(index)
		} else {
			$(this).parent('li').addClass('shake')

			setTimeout(() => {
				$(this).parent('li').removeClass('shake')
			}, 500)
		}
	})
}

function set_cookies_index(index) {
	if (Cookies.get('opened-calendar-index')) {
		const index_array = JSON.parse(Cookies.get('opened-calendar-index'))
		const new_index_array = index_array.filter(item => item !== index).concat([index])

		Cookies.set('opened-calendar-index', JSON.stringify(new_index_array), {
			expires: 30,
		})
	} else {
		const index_array = [index]
		const index_array_json = JSON.stringify(index_array)
		Cookies.set('opened-calendar-index', index_array_json, { expires: 30 })
	}
}

function has_been_opened(index) {
	if (!Cookies.get('opened-calendar-index')) {
		return false
	}

	const opened_index = JSON.parse(Cookies.get('opened-calendar-index'))

	if (opened_index.indexOf(index + 1) >= 0) {
		return true
	} else {
		return false
	}
}
